// Kleur volgt de foto in beeld (11-10-2026).
// Aanvulling op tc-swatch-fix.js (daar: klik op een fotothumbnail kiest de kleur).
// Hier: ook bij de pijltjes, vegen of op een andere manier naar een foto van één kleur gaan,
// springt de kleurknop mee. De foto die in beeld is blijft staan.
// Kleur van een foto = de kleur waar de foto als variantfoto aan hangt, anders de kleur in de
// alt-tekst ("Bear Loungewear in Navy, back"). Foto's met meerdere kleuren (Use-foto) veranderen niets.
// De maat-hulp uit tc-swatch-fix.js (uitverkochte maat → dichtstbijzijnde leverbare maat) blijft werken,
// want de kleur wordt via een gewoon change-event gekozen.
(function () {
  function readJSON(id) {
    var el = document.getElementById(id);
    if (!el) { return null; }
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function fire(radio) {
    var ev;
    try { ev = new Event('change', { bubbles: true }); }
    catch (e) { ev = document.createEvent('Event'); ev.initEvent('change', true, false); }
    radio.dispatchEvent(ev);
  }

  function escapeRe(s) { return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); }

  function stripUrl(u) {
    // //tonycharlie.com/cdn/shop/files/X.jpg?v=1&width=900 → /cdn/shop/files/X.jpg
    u = String(u || '').replace(/^https?:/, '').replace(/^\/\/[^\/]+/, '');
    return u.split('?')[0];
  }

  function init() {
    var form = document.getElementById('TC-ProductForm');
    var variants = readJSON('TC-VariantData');
    var mainImg = document.getElementById('TC-MainImage');
    if (!form || !variants || !variants.length || !mainImg) { return; }

    var colorBlock = null;
    Array.prototype.slice.call(form.querySelectorAll('.option-block')).forEach(function (b) {
      var l = b.querySelector('.option-label');
      var n = l ? l.textContent.trim().toLowerCase() : '';
      if (!colorBlock && /colou?r|kleur/.test(n)) { colorBlock = b; }
    });
    if (!colorBlock) { return; }
    var cp = parseInt(colorBlock.getAttribute('data-option-position'), 10) - 1;
    var colorRadios = Array.prototype.slice.call(colorBlock.querySelectorAll('.swatch-radio'));
    if (colorRadios.length < 2) { return; }

    var thumbs = Array.prototype.slice.call(document.querySelectorAll('[data-tc-thumb]'));
    if (!thumbs.length) { return; }

    var mediaColors = {};
    variants.forEach(function (v) {
      if (!v.featured_media || !v.featured_media.id) { return; }
      var key = String(v.featured_media.id);
      mediaColors[key] = mediaColors[key] || [];
      if (mediaColors[key].indexOf(v.options[cp]) === -1) { mediaColors[key].push(v.options[cp]); }
    });
    var titleEl = document.querySelector('.product-info h1');
    var title = titleEl ? titleEl.textContent.trim().toLowerCase() : '';

    function colorForThumb(thumb) {
      var linked = mediaColors[String(thumb.getAttribute('data-tc-media-id'))];
      if (linked && linked.length === 1) { return linked[0]; }
      var alt = (thumb.getAttribute('alt') || '').toLowerCase();
      if (title) { alt = alt.split(title).join(' '); }
      var found = colorRadios.map(function (r) { return r.value; }).filter(function (c) {
        return new RegExp('(^|[^a-z0-9])' + escapeRe(c.toLowerCase()) + '([^a-z0-9]|$)').test(alt);
      });
      found = found.filter(function (c) {
        return !found.some(function (o) { return o !== c && o.toLowerCase().indexOf(c.toLowerCase()) !== -1; });
      });
      return found.length === 1 ? found[0] : null;
    }

    // Welke thumbnail hoort bij de foto die nu groot in beeld is?
    function currentThumb() {
      var src = stripUrl(mainImg.getAttribute('src'));
      var hit = null;
      thumbs.forEach(function (t) {
        if (!hit && stripUrl(t.getAttribute('data-full') || t.getAttribute('src')) === src) { hit = t; }
      });
      if (hit) { return hit; }
      var active = null;
      thumbs.forEach(function (t) { if (!active && t.classList.contains('is-active')) { active = t; } });
      return active;
    }

    var busy = false;
    var timer = null;

    function sync() {
      timer = null;
      if (busy) { return; }
      var thumb = currentThumb();
      if (!thumb) { return; }
      var color = colorForThumb(thumb);
      if (!color) { return; }
      var radio = null;
      colorRadios.forEach(function (r) { if (r.value === color) { radio = r; } });
      if (!radio || radio.checked) { return; }
      busy = true;
      radio.checked = true;
      fire(radio);
      // De kleurwissel zet de hoofdfoto van die kleur in beeld; zet de foto van de klant terug.
      if (currentThumb() !== thumb) { thumb.click(); }
      busy = false;
    }

    function schedule() {
      if (busy || timer) { return; }
      timer = setTimeout(sync, 60);
    }

    var obs = new MutationObserver(schedule);
    obs.observe(mainImg, { attributes: true, attributeFilter: ['src'] });
    thumbs.forEach(function (t) { obs.observe(t, { attributes: true, attributeFilter: ['class'] }); });
  }

  function start() { setTimeout(init, 0); }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', start); }
  else { start(); }
})();
